module.exports = __webpack_public_path__ + "img/gz_lc_img_ch.eecd5da9.png";